
<div id="encabezado">
  <app-encabezado-expediente></app-encabezado-expediente>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="row">
    <div class="col-12 d-flex justify-content-end mb-5">
      <button
        class="btn-govco outline-btn-govco hvr-shrink mx-2"
        aria-label="Ver solicitudes">
        <span class="govco-svg govco-search-plus me-2"></span>
        {{ 'detalle-supersociedades.solicitudes' | translate }}
      </button>
      <button
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        aria-label="Crear nuevo expediente">
        <span class="govco-svg govco-plus-circle me-2"></span>
        {{ 'detalle-supersociedades.crear' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="wrapper__headerComponent container my-5">
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <a class="nav-link active" id="detalle-tab"
         data-bs-toggle="tab"
         href="#detalle" role="tab"
         aria-controls="active"
         aria-selected="true">
        {{"supersociedades-insolvencia.info-general" | translate}}
      </a>
      <a class="nav-link" id="documentos-tab"
         data-bs-toggle="tab"
         href="#documentos" role="tab"
         aria-controls="active"
         aria-selected="true">
        {{"supersociedades-insolvencia.adjuntos" | translate}}
      </a>
    </li>
  </ul>
  <div class="tab-content" id="myTabContent">
    <!-- Contenido del Tab Información general -->
    <div class="tab-pane fade show active" id="detalle" role="tabpanel" aria-labelledby="detalle-tab">
      <div class="row align-items-center">
        <div class="col-12 col-md-3"></div>
        <div class="col-12 col-md-6">
          <h2 class="text-center h3-tipografia-govco mb-0">
            {{"supersociedades-insolvencia.titulo" | translate}}
          </h2>
        </div>
      </div>

      <div class="contenedor-tabla w-100">
        <app-table
          [columnas]="columnas"
          [acciones]="acciones"
          [datos]="datosExpedienteSSI"
          (eventoAccion)="accionesExpedienteSSI($event)"
        >
        </app-table>
      </div>
      <!-- Histórico -->
      <div class="wrapper__headerComponent container my-5" *ngIf="mostrarHistorico">
        <div class="row align-items-center">
          <div class="col-12 col-md-3"></div>
          <div class="col-12 col-md-6">
            <h2 class="text-center h3-tipografia-govco mb-0">
              {{"supersociedades-insolvencia.historico" | translate}} {{idExpedienteSSI}}
            </h2>
          </div>
        </div>
        <div class="contenedor-tabla w-100">
          <app-table
            [columnas]="columnasHistorico"
            [datos]="datosHistoricoSSI"
          ></app-table>
          <app-table
            [columnas]="columnasHistoricoSegundaParte"
            [acciones]="accionesHistoricoSegundaParte"
            [datos]="datosHistoricoSegundaParteSSI"
            (eventoAccion)="accionesHistoricoSSI($event)"
          ></app-table>
        </div>
      </div>
      <!-- Tabla botón ver -->
      <div class="wrapper__headerComponent container my-5" *ngIf="mostrarDetalle">
        <div class="row align-items-center">
          <div class="col-12 col-md-3"></div>
          <div class="col-12 col-md-6">
            <h2 class="text-center h3-tipografia-govco mb-0">
              {{"supersociedades-insolvencia.detalle-transaccion" | translate}}
            </h2>
          </div>
        </div>
        <div class="contenedor-tabla w-100">
          <app-table
            [columnas]="columnasTablaVer"
            [datos]="datosEstadoFinancieroSSI"
          ></app-table>
        </div>
      </div>
    </div>

    <!-- Contenido del Tab Documentos -->
    <div class="tab-pane fade show active" id="documentos" role="tabpanel" aria-labelledby="documentos-tab">
      <app-documentos-supersociedades-insolvencia
        [idExpediente]="this.idExpediente">
      </app-documentos-supersociedades-insolvencia>
    </div>
  </div>
</div>

